module.exports = __webpack_public_path__ + "img/live_body_m.7bd8548d.png";